import React from 'react';
import { Button, Tag, Tooltip } from 'antd';
import  { EditOutlined} from '@ant-design/icons';
import { Agent as AgentResponse } from '@/DTOS/Agent/Response/Agent';

export const AgentColumn = (handleEdit: (record: AgentResponse) => void) => [
  
  {
    title: 'Agent Id',
    dataIndex: 'id',
    key: 'id',
    hidden: true,
  },
  {
    title: 'Nume',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Telefon',
    dataIndex: 'phone',
    key: 'phone',
    render: (phoneNumber: string[]) => (
      <div className='phone-column'>
        {phoneNumber?.map((item: string, index: number) => (
          <Tag color={'blue'} key={`phone_${index}`}>
            {item}
          </Tag>
        ))}
        {!phoneNumber && <Tag color={'blue'}>-</Tag>}
      </div>
    ),
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    render: (email: string[]) => (
      <div className='email-column'>
        {email?.map((item: string, index: number) => (
          <Tag color={'blue'} key={`email_${index}`}>
            {item}
          </Tag>
        ))}
        {!email && <Tag color={'blue'}>-</Tag>}
      </div>
    ),
  },
  {
    title: 'Rol',
    dataIndex: 'role',
    key: 'role',
    render: (role: string[]) => (
      <div className='role-column'>
        {role?.map((item: string, index: number) => (
          <Tag color={'blue'} key={`role_${index}`}>
            {item}
          </Tag>
        ))}
        {!role && <Tag color={'blue'}>-</Tag>}
      </div>
    ),
  },
  {
    title: 'Status',
    dataIndex: 'isActive',
    key: 'isActive',
    render: (isActive: boolean) => (isActive ? 'Activ' : 'Inactiv'),
  },
  {
    title: 'Actiune',
    dataIndex: '',
    key: 'actions',
    render: (record: AgentResponse) => (
      <Tooltip title='Modifica'>
      <Button onClick={() =>  handleEdit(record)} icon={<EditOutlined/>}></Button>
      </Tooltip>
    ),
    width: 120,
    fixed: 'right'
  },
];
